'use client';

// Barre de la vitrine : marque + réglages + appel à l'action.
//
// MÊME GRAMMAIRE que la barre de l'application (`AppHeader`) : même pastille de marque, mêmes
// boutons ronds (`headerChrome`), mêmes popovers de thème et de langue. Un visiteur qui
// s'inscrit passe de l'une à l'autre en une navigation — les voir diverger donnerait
// l'impression de changer de site.
//
// Ce qu'elle NE reprend pas : la navigation centrale, qui mène à des écrans réservés aux
// comptes connectés. Une barre publique n'a pas à afficher des destinations inaccessibles.
//
// Auth-aware : déjà connecté, on propose d'ouvrir l'application plutôt que de s'inscrire.

import Link from 'next/link';

import { BrandWordmark } from '@/components/app/BrandWordmark';
import { LanguageMenu } from '@/components/app/LanguageMenu';
import { ThemeMenu } from '@/components/app/ThemeMenu';
import { ACTION } from '@/components/app/headerChrome';
import { cn } from '@/lib/cn';
import { useT } from '@/hooks/useT';
import { useMe } from '@/queries/auth';
import { fontStyle } from '@/theme/typography';

export function LandingNav() {
  const { t } = useT('landing');
  const { data: user } = useMe();

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-surface">
      <nav className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between gap-4 px-3">
        <Link
          href="/"
          className="flex w-fit items-center rounded-xl bg-brand px-3.5 py-1.5 text-brand-on transition-[opacity,transform] duration-200 hover:opacity-90 active:scale-95"
        >
          <BrandWordmark className="h-7 w-auto" />
        </Link>

        <div className="flex items-center gap-2">
          <ThemeMenu triggerClassName={ACTION} />
          <LanguageMenu triggerClassName={cn(ACTION, 'w-auto gap-1.5 px-3')} />

          <span className="mx-1 hidden h-6 w-px bg-border sm:block" />

          {user ? (
            <Link
              href="/library"
              style={fontStyle('button')}
              className="flex h-10 items-center rounded-full bg-action px-4 text-action-on transition-colors hover:bg-action-hover"
            >
              {t('nav.openApp')}
            </Link>
          ) : (
            <>
              <Link
                href="/sign-in"
                style={fontStyle('button')}
                className="hidden h-10 items-center rounded-full px-3 text-text-primary transition-colors hover:bg-fill-subtle sm:flex"
              >
                {t('nav.signIn')}
              </Link>
              <Link
                href="/sign-up"
                style={fontStyle('button')}
                className="flex h-10 items-center rounded-full bg-action px-4 text-action-on transition-colors hover:bg-action-hover"
              >
                {t('nav.signUp')}
              </Link>
            </>
          )}
        </div>
      </nav>
    </header>
  );
}
